import React, { useContext, useEffect, useState } from 'react'
import ViewUserProfil from './ViewUserProfil'
import { UserContext } from '../login/LoginForm';
import { AuthContext } from '../login/AuthContext';
import CardGrid from '../GridViewMain/CardGrid';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import FullCardGrid from '../GridViewMain/FullCardGrid/FullCardGrid';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
import { useDelayedAuthCheck } from '../UsefulComponent/useDelayedAuthCheck';
import SeoHelmet from '../../Seo/SeoHelmet';
import { useSport } from '../../utils/SportsProvider';
const FullUserprofilPage = () => {
  

  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.FullUserprofilPage[key][currentLang]; // Adjust the path according to your JSON structure
 
  const { userId, loading  } = useContext(AuthContext);
    const [userCards, setUserCards] = useState([]);
    const [groupedCards,setGroupedCards] = useState([])
    const [viewAsGrid,setViewAsGrid]=useState(false)
    const [userData,setUserData] = useState([])
    const [userFeedback,setUserFeedback] = useState({ Seller: [], Buyer: [] });
    //const { id } = useParams();
    const { userName } = useParams();
 
    const navigate = useNavigate();
    // Import the getItem function from the utils_localStorage module
  
    // Retrieve the data from local storage
    
const { state } = useSport();

const fetchCardData = async (thisUserId) => {
  try {
    const sport = state?.sport || "Hockey";

    const res = await fetch(
      `${process.env.REACT_APP_API_BASE}/getUserCards/${thisUserId}?sport=${encodeURIComponent(sport)}`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    const json = await res.json();

    setUserCards(json);
    console.log("regarde ici", json);
  } catch (error) {
    console.log("Error fetching card data:", error);
  }
};
    // const fetchUserData = async () => {
    //     const res = await fetch(`${process.env.REACT_APP_API_BASE}/getUser/${id}`); // Use the id from the URL
    //     const json = await res.json();
    //     console.log(json);
    //     setUserData({
    //       ShowName: json.ShowName,
    //       City: json.City,
    //       State: json.State,
    //       Country: json.Country,
    //       EbayProfile: json.EbayProfile,
    //       FacebookProfile: json.FacebookProfile,
    //       ProfilPicture: json.ProfilPicture,
    //     });
    //   };
    useEffect(() => {
  if (!userData.thisUserId) return;
  fetchCardData(userData.thisUserId);
}, [userData.thisUserId, state.sport]);

    const fetchUserDataByUsername = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/getUser/Username/${userName}`, {
          method: 'GET',
          credentials: 'include',
        });
    
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
    
        const json = await res.json();
    
        console.log('json', json);
    
        setUserData({
          thisUserId: json.UserId,
          Description: json.Description,
          ShowName: json.ShowName,
          City: json.City || "",         // Safely handle missing data
          State: json.State || "",
          Country: json.Country || "",
          EbayProfile: json.EbayProfile || "",
          FacebookProfile: json.FacebookProfile || "",
          TwitterProfile: json.TwitterProfile || "",
          EpackProfile: json.EpackProfile || "",
          ComcProfile: json.ComcProfile || "",
          InstagramProfile: json.InstagramProfile || "",
          ProfilPicture: json.ProfilPicture || "",
          NumberOfTransactions: json.NumberOfTransactions,
          AverageRating: json.AverageRating,
        });
    
        fetchFeedbackFromUser(json.UserId);
        fetchCardData(json.UserId);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    
    

      const fetchFeedbackFromUser = async (providedUserId) => {
        try {
            console.log('userFeedback userId',providedUserId)
            const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/feedback/Get/${providedUserId}`);
            const feedbacks = await res.json();
            
            const organizedFeedback = feedbacks.reduce((acc, feedbackItem) => {
              const type = feedbackItem.Type; // 'Seller' or 'Buyer'
              if (!acc[type]) acc[type] = [];
              acc[type].push(feedbackItem);
              return acc;
          }, { Seller: [], Buyer: [] });
          setUserFeedback(organizedFeedback);
        } catch (error) {
            console.error('Error fetching feedback:', error);
        }
    };
    useEffect(() => {
      if (!loading) {
        fetchUserDataByUsername();
      }
    }, [loading, userName]);


      useEffect(() => {
        if (userCards.length > 0&&viewAsGrid) {
          const fetchedCards = userCards;
          console.log('fetchedCards',fetchedCards)
          const cardMap = fetchedCards.reduce((acc, card) => {
           
            const cardDetails = {
              // Ensure all properties are validated against being null or empty
              id: card.id || "",
              imageFront: card.ImageFront || "",
              imageUserBack: card.ImageUserBack || "",
              graded: card.Graded || "",
              gradeCompany: card.GradeCompany || "",
              grade: card.Grade || "",
              condition: card.Condition || "",
              estimateValue: parseFloat(card.EstimateValue) || "",
              price:parseFloat(card.Price)||"",
              isForSale: card.isForSale || "",
              isForTrade: card.isForTrade || "",
              isOnEbay: card.isOnEbay || "",
              userId: card.UserId || "",
              ShowName: card.ShowName || "",
              Rating: parseFloat(card.Rating) || 4,
              Country: card.Country || "",
              Shipping:card.Shipping ||0,
              totalSales:24,
              ProfilPicture:card.ProfilPicture||""
            };
      
            if (!acc.has(card.CardId)) {
              // Initialize with the current card's details and set the lowestEstimateValue to the current card's EstimateValue
              acc.set(card.CardId, {
                ...card,
                sameCardCount: 1,
                grades: {
                  Raw: { 
                    count: card.Graded && card.Graded.toLowerCase() === "raw" ? 1 : 0, 
                    lowestEstimateValue: card.Graded && card.Graded.toLowerCase() === "raw" ? card.EstimateValue : Infinity 
                  },
                  Graded: { 
                    count: card.Graded && card.Graded.toLowerCase() !== "raw" ? 1 : 0, 
                    lowestEstimateValue: card.Graded && card.Graded.toLowerCase() !== "raw" ? card.EstimateValue : Infinity 
                  },
                },
                blend: [cardDetails], // Initialize blend as an array with the current card's details
              });
            } else {
              const entry = acc.get(card.CardId);
              entry.sameCardCount += 1;
              entry.blend.push(cardDetails); // Append the current card's details to the blend array
      
              // Update grades logic and lowestEstimateValue
              if (card.Graded && card.Graded.toLowerCase() === "raw") {
                entry.grades.Raw.count += 1;
                entry.grades.Raw.lowestEstimateValue = Math.min(entry.grades.Raw.lowestEstimateValue, card.EstimateValue);
              } else if (card.Graded && card.Graded.toLowerCase() !== "raw") {
                entry.grades.Graded.count += 1;
                entry.grades.Graded.lowestEstimateValue = Math.min(entry.grades.Graded.lowestEstimateValue, card.EstimateValue);
              }
      
              acc.set(card.CardId, entry);
            }
      
            return acc;
          }, new Map());
      
          setGroupedCards(cardMap);
          console.log('cardMap',cardMap)
        }
      }, [userCards,viewAsGrid]);

  return (<>
   
   {userData&&(<><ViewUserProfil userData={userData} userFeedback={userFeedback}/>
   <SeoHelmet type="profile" data={{ username: userData.ShowName, profilePicture: userData.ProfilePicture }} /></>)}
        <section className='grid'>
      <div className="contentfront">
      <div className='justify top-page' >
        <h1>{userName}{t("'s Collection")}</h1>
      </div>
      {/* Render the userCards instead of dummyCards */}
      <FullCardGrid setCards={setUserCards}cards={userCards} groupedCards={groupedCards} viewAsGrid={viewAsGrid} viewOnly={true} cardGridType={'Profil'}/>
      </div>
    </section>
      </>
  )
}

export default FullUserprofilPage